"use strict";

function _LayoutActions() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};

  this.initAllReady = function () {};

  this.setActiveSection = function (id) {
    return {
      type: SET_ACTIVE_SECTION,
      payload: {
        section_id: id
      }
    };
  };

  this.setActiveURIs = function (current, previous) {
    return {
      type: SET_ACTIVE_URI,
      payload: {
        current_uri: current,
        previous_uri: previous
      }
    };
  };

  this.setActiveFlow = function (id) {
    return {
      type: SET_ACTIVE_FLOW,
      payload: {
        flow_id: id
      }
    };
  };
}